<template>
  <div class="fixed top-0 w-full z-100">
    <NavigationMobileTop v-if="!isSimpleHeader" :links="mobileLinks">
      <template #drawer-extra>
        <div class="border-b-1 border-solid border-grey-background-contrast py-24 px-8">
          <form
            class="border-1 border-solid border-grey-divider-subdued flex m-auto navigation-search shadow-lg accessible-border"
            role="search"
            @submit.prevent="submitMastheadSearch"
          >
            <button class="px-16" type="submit">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>Search</title>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.83008 12C3.51637 12 0.830078 9.31371 0.830078 6C0.830078 2.68629 3.51637 0 6.83008 0C10.1438 0 12.8301 2.68629 12.8301 6C12.8301 7.34075 12.3903 8.57879 11.6472 9.57774L14.643 12.5451C14.9863 12.8852 14.9889 13.4392 14.6489 13.7825C14.3088 14.1259 13.7548 14.1285 13.4114 13.7884L10.41 10.8155C9.41065 11.5596 8.1718 12 6.83008 12ZM6.83008 10.25C9.17729 10.25 11.0801 8.34721 11.0801 6C11.0801 3.65279 9.17729 1.75 6.83008 1.75C4.48287 1.75 2.58008 3.65279 2.58008 6C2.58008 8.34721 4.48287 10.25 6.83008 10.25Z"
                  fill="#282930"
                />
              </svg>
            </button>
            <label for="search_strategy_mobile" class="sr-only">Find care</label>
            <select
              id="search_strategy_mobile"
              v-model="searchCareType"
              class="text-m px-8 py-12 w-3/5 select border-r-1 border-solid border-grey-background-contrast"
              name="search_strategy"
            >
              <option value="babysitter_job">Babysitting jobs</option>
              <option value="nanny_job">Nanny jobs</option>
              <option value="special_needs_job">Special needs jobs</option>
              <option value="companion_care_job">Care companion jobs</option>
              <option value="pet_care_job">Pet care jobs</option>
              <option value="housekeeping_job">Housekeeping jobs</option>
            </select>
            <label for="masthead_zipcode_mobile" class="sr-only">Enter zip code here</label>
            <input
              id="masthead_zipcode_mobile"
              v-model="searchZipcode"
              class="pl-16 pr-8 w-1/3"
              type="text"
              placeholder="in zip"
              maxlength="5"
            />
          </form>
        </div>
      </template>
    </NavigationMobileTop>

    <header
      id="header-desktop"
      class="sitter-desktop-nav-bar"
      :class="isSimpleHeader ? 'flex items-center h-48 md-1:h-80' : 'hidden lg:block'"
    >
      <nav class="flex grow items-center w-full">
        <a v-if="!isSimpleHeader" href="/" class="pl-48 pr-32">
          <img src="@/images/components/header/sittercity-mark-logo.svg" alt="Sittercity" class="w-48" />
        </a>
        <div v-else class="pl-16 md-1:pl-48">
          <img src="@/images/components/header/sittercity-mark-logo.svg" alt="Sittercity" class="w-36 md-1:w-48" />
        </div>

        <div v-if="!isSimpleHeader">
          <form
            class="border-1 border-solid border-grey-divider-subdued flex m-auto navigation-search shadow-lg"
            role="search"
            @submit.prevent="submitMastheadSearch"
          >
            <button class="px-16 mr-2 accessible-border" type="submit">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>Search</title>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.83008 12C3.51637 12 0.830078 9.31371 0.830078 6C0.830078 2.68629 3.51637 0 6.83008 0C10.1438 0 12.8301 2.68629 12.8301 6C12.8301 7.34075 12.3903 8.57879 11.6472 9.57774L14.643 12.5451C14.9863 12.8852 14.9889 13.4392 14.6489 13.7825C14.3088 14.1259 13.7548 14.1285 13.4114 13.7884L10.41 10.8155C9.41065 11.5596 8.1718 12 6.83008 12ZM6.83008 10.25C9.17729 10.25 11.0801 8.34721 11.0801 6C11.0801 3.65279 9.17729 1.75 6.83008 1.75C4.48287 1.75 2.58008 3.65279 2.58008 6C2.58008 8.34721 4.48287 10.25 6.83008 10.25Z"
                  fill="#282930"
                />
              </svg>
            </button>
            <label for="search_strategy_desktop" class="sr-only">Find care</label>
            <select
              id="search_strategy_desktop"
              v-model="searchCareType"
              class="text-m px-8 py-12 w-3/5 mr-2 select border-r-1 border-solid border-grey-background-contrast accessible-border"
              name="search_strategy"
            >
              <option value="babysitter_job">Babysitting jobs</option>
              <option value="nanny_job">Nanny jobs</option>
              <option value="special_needs_job">Special needs jobs</option>
              <option value="companion_care_job">Care companion jobs</option>
              <option value="pet_care_job">Pet care jobs</option>
              <option value="housekeeping_job">Housekeeping jobs</option>
            </select>
            <label for="masthead_zipcode_desktop" class="sr-only">Enter zip code here</label>
            <input
              id="masthead_zipcode_desktop"
              v-model="searchZipcode"
              class="pl-16 pr-8 w-1/3 accessible-border"
              type="text"
              placeholder="in zip"
              maxlength="5"
            />
          </form>
        </div>

        <ul class="flex ml-auto text-grey-clickable pr-16 md-1:pr-24" :class="isSimpleHeader ? 'items-center' : 'pt-28'">
          <li v-if="!isSimpleHeader" class="mr-24">
            <router-link
              to="/adventures"
              class="border-b-2 border-solid border-transparent hover:border-brand-contrast link--tertiary accessible-border pt-18 pb-18 pl-10 pr-10"
              >Adventures</router-link
            >
          </li>
          <li v-if="!isSimpleHeader" class="mr-24">
            <router-link
              to="/availability"
              class="border-b-2 border-solid border-transparent hover:border-brand-contrast link--tertiary accessible-border pt-18 pb-18 pl-10 pr-10"
              >Availability</router-link
            >
          </li>
          <li v-if="!isSimpleHeader" class="mr-24 relative">
            <router-link
              to="/provider/bookings"
              class="border-b-2 border-solid border-transparent hover:border-brand-contrast link--tertiary accessible-border pt-18 pb-18 pl-10 pr-10"
              >Bookings</router-link
            >
            <span
              v-if="unreadBookingRequestsCount > 0"
              class="nav-unread-messages-count bg-brand-contrast text-center text-foreground font-semibold inline-block h-20 w-20 rounded-full text-xs tracking-tighter leading-5 absolute -top-6 -right-8"
              >{{ unreadBookingRequestsCount }}</span
            >
          </li>
          <li v-if="!isSimpleHeader" class="flex mr-24 relative">
            <router-link
              to="/messages"
              class="border-b-2 border-solid border-transparent pb-32 pt-4 hover:border-brand-contrast accessible-border"
            >
              <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>Messages</title>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2 0H18C19.1046 0 20 0.89543 20 2V14C20 15.1046 19.1046 16 18 16H2C0.89543 16 0 15.1046 0 14V2C0 0.89543 0.89543 0 2 0ZM2 3.37073V14H18V3.37073L10 10.8707L2 3.37073ZM3.46211 2L10 8.12927L16.5379 2H3.46211Z"
                  fill="#4B4C52"
                />
              </svg>
            </router-link>
            <span
              v-if="unreadMessageCount > 0"
              class="nav-unread-messages-count bg-brand-contrast text-center text-foreground font-semibold inline-block h-20 w-20 rounded-full text-xs tracking-tighter leading-5 absolute -top-6 -right-10"
              >{{ unreadMessageCount }}</span
            >
          </li>
          <li ref="desktopDropdownContainer">
            <button class="flex items-center accessible-border" data-testid="sitter-account-menu" @click="toggleDesktopDropdown">
              {{ firstName }}
              <svg
                aria-hidden="true"
                class="ml-4"
                :class="{ 'rotate-180 transform': desktopDropdownOpen }"
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.664906 0.5H9.33509C9.62634 0.5 9.82797 0.635602 9.93999 0.906805C10.052 1.17801 10.0072 1.41124 9.80557 1.60651L5.47048 5.80473C5.33605 5.93491 5.17923 6 5 6C4.82077 6 4.66395 5.93491 4.52952 5.80473L0.194431 1.60651C-0.00720122 1.41124 -0.0520082 1.17801 0.0600095 0.906805C0.172027 0.635602 0.37366 0.5 0.664906 0.5Z"
                  fill="#4B4C52"
                />
              </svg>
            </button>

            <div v-if="desktopDropdownOpen" class="absolute bg-foreground p-12 right-6 shadow-lg top-14 z-101">
              <button class="flex items-center ml-auto mr-6 mb-16" @click="toggleDesktopDropdown">
                {{ firstName }}
                <svg
                  class="ml-4 rotate-180 transform"
                  aria-hidden="true"
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.664906 0.5H9.33509C9.62634 0.5 9.82797 0.635602 9.93999 0.906805C10.052 1.17801 10.0072 1.41124 9.80557 1.60651L5.47048 5.80473C5.33605 5.93491 5.17923 6 5 6C4.82077 6 4.66395 5.93491 4.52952 5.80473L0.194431 1.60651C-0.00720122 1.41124 -0.0520082 1.17801 0.0600095 0.906805C0.172027 0.635602 0.37366 0.5 0.664906 0.5Z"
                    fill="#4B4C52"
                  />
                </svg>
              </button>

              <ul>
                <li v-if="!isSimpleHeader" class="pb-12">
                  <a href="/account/settings">Account</a>
                </li>
                <li class="pb-12">
                  <a href="https://www.sittercity.com/trust-and-safety">Trust &amp; Safety</a>
                </li>
                <li class="pb-12">
                  <a href="https://support.sittercity.com/" rel="external">Help</a>
                </li>
                <li class="pb-12">
                  <a href="/logout" rel="nofollow">Log out</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </header>
  </div>
</template>

<script lang="ts">
import debounce from 'lodash/debounce';

import NavigationMobileTop from '@/components/nav/NavigationMobileTop.vue';

export default {
  name: 'SitterNav',
  components: { NavigationMobileTop },
  data() {
    return {
      desktopDropdownOpen: false,
      hasScrolled: false,
      handleScroll: null as any,
      handleClickOutside: null as any,
      searchCareType: 'babysitter_job',
      searchZipcode: '',
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/getAccount'];
    },
    firstName(): string {
      return this.account?.firstName || '';
    },
    isSimpleHeader(): boolean {
      return this.$route.matched.some((record) => record.meta?.simpleHeader);
    },
    selectedCareType(): string {
      const careTypeMap: Record<string, string> = {
        babysitter: 'babysitter_job',
        nanny: 'nanny_job',
        special_needs: 'special_needs_job',
        companion_care: 'companion_care_job',
        pet_care: 'pet_care_job',
        housekeeping: 'housekeeping_job',
      };

      const params = new URLSearchParams(window.location.search);
      const careType = params.get('careType');
      if (careType && careTypeMap[careType]) {
        return careTypeMap[careType];
      }

      const accountCareType = this.account?.careType?.toLowerCase();
      if (accountCareType && careTypeMap[accountCareType]) {
        return careTypeMap[accountCareType];
      }

      return 'babysitter_job';
    },
    defaultZipCode(): string {
      const params = new URLSearchParams(window.location.search);
      return params.get('zipcode') || this.$store.getters['account/getZipCode'] || '';
    },
    unreadMessageCount(): number {
      return this.$store.getters['navigation/unreadMessageCount'];
    },
    unreadBookingRequestsCount(): number {
      return this.$store.getters['navigation/unreadBookingRequestsCount'];
    },
    mobileLinks() {
      return [
        { href: '/account/providers/dashboard', label: 'Home' },
        { href: '/adventures', label: 'Adventures' },
        { href: '/availability', label: 'Availability' },
        {
          href: '/provider/bookings',
          label: 'Bookings',
          badgeCount: this.$store.getters['navigation/unreadBookingRequestsCount'],
        },
        { href: 'https://www.sittercity.com/trust-and-safety', label: 'Trust & Safety' },
        { href: 'https://support.sittercity.com/', label: 'Help', external: true },
        { href: '/account/settings', label: 'Account' },
        { href: '/logout', label: 'Log out' },
      ];
    },
  },
  watch: {
    selectedCareType: {
      immediate: true,
      handler(careType: string) {
        this.searchCareType = careType;
      },
    },
    defaultZipCode: {
      immediate: true,
      handler(zipcode: string) {
        this.searchZipcode = zipcode;
      },
    },
  },
  created() {
    this.handleScroll = debounce(() => {
      this.hasScrolled = window.scrollY > 0;
    }, 250);
    this.handleClickOutside = (event: Event) => {
      const dropdownContainer = this.$refs.desktopDropdownContainer as HTMLElement;
      if (dropdownContainer && !dropdownContainer.contains(event.target as Node)) {
        this.desktopDropdownOpen = false;
      }
    };
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.$store.dispatch('navigation/startPolling');
  },
  beforeUnmount() {
    this.$store.dispatch('navigation/stopPolling');
    document.body.classList.remove('overflow-hidden');
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleDesktopDropdown() {
      this.desktopDropdownOpen = !this.desktopDropdownOpen;
    },
    submitMastheadSearch() {
      const query: Record<string, string> = {
        careType: this.searchCareType.replace('_job', ''),
      };

      const zipcode = this.searchZipcode.trim();
      if (zipcode) {
        query.zipcode = zipcode;
      }

      this.$router.push({ name: 'JobSearch', query });
    },
  },
};
</script>

<style lang="scss" scoped>
.sitter-desktop-nav-bar {
  @apply bg-foreground border-b-1 border-solid border-grey-divider-subdued w-full z-100;
}
</style>
